<ul class="x-navigation sidebar-margin leftsidenavul" *ngIf="isVisitsInMobileView()">
  <!-- Loop through nav structure -->
  <li *ngFor="let menu of navStructure; let i = index" class="leftnavmainitems" [ngClass]="{ 'xn-openable': menu.type == 'menu'}" [class.active]="isActive(menu)"
  (click)="menu?.type == 'feature' ? menuNavigation(menu) : null">
    <a class="navChilditem" id="menu.name">
      <span>
        <img [src]="'assets/images/New_Icons/' + menu.icon" alt="'menu.name' + Icon" alt="Nav icon"  class="brand-icon"/>
      </span>
      <span class="xn-text">{{ menu.name }}</span>
    </a>
    <!-- Submenus or features directly inside main menu -->
    <ul class="innerullist" *ngIf="menu.type == 'menu'">
      <li *ngFor="let child of menu.children" [ngClass]="{ 'xn-openable': child.type == 'submenu'}" style="cursor: pointer;" [class.active]="isActive(child)"
      (click)="child?.type == 'feature' ? menuNavigation(child) : null">
        <a class="adminpanelullia">
          <span *ngIf="child.icon">
            <img [src]="'assets/images/New_Icons/' + child.icon" alt="'child.name' + Icon" alt="Nav icon"/>
          </span>
          <span class="xn-text leftnavicon">{{ child.name }}</span>
        </a>
        <!--features inside sub menus-->
        <ul class="adminpanelulliaul" *ngIf="child.type == 'submenu'">
          <li *ngFor="let feature of child.children" class="nav-item" [class.active]="isActive(feature)" (click)="menuNavigation(feature)">
            <a class="navChilditem">
              <span class="xn-text">{{ feature.name }}</span>
            </a>            
          </li>
        </ul>
      </li>
    </ul>
  </li>
</ul>
